import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'
import Home from './screens/Home';
import Layout from './components/Layout';
import PriyacyPolicy from './screens/PriyancyPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path='/' element={<Home />} />
          <Route path='/privacy-policy' element={<PriyacyPolicy />} />
        </Route>
      </Routes>
    </Router>

  );
}

export default App;
